import { memo } from 'react';

import ImageOverlay from '@/Pages/Clip/ClipPlayer/ClipAssets/ImageOverlay/ImageOverlay';

const ClipCustomizerImagesPopup = ({ closePopup }: { closePopup: () => void }) => {
  return (
    <div className="flex max-h-[54vh] w-[23rem] flex-col overflow-y-auto rounded-lg border bg-white shadow">
      <div className="sticky top-0 z-10 mb-4 flex items-center justify-between bg-white px-4 pt-3">
        <div className="text-lg font-medium">Images</div>
      </div>
      <div className="mb-4 px-4">
        <ImageOverlay onUploadComplete={closePopup} />
      </div>
    </div>
  );
};

export default memo(ClipCustomizerImagesPopup);
